import React, { Fragment, useContext } from 'react';
import styles from './MoreOptionsButton.module.scss';
import { SFDivider, SFIconButton, SFMenu, SFMenuItem } from 'sfui';
import { MediaContext } from 'ui-smartforce-settings';

export interface MoreOptionsButtonProps {
  isDownloadDisabled: boolean;
  isAdvancedFiltersActive: boolean;
  sortLabel: string;
  onClick: (value: string) => void;
}

export const MoreOptionsButton = React.forwardRef<
  HTMLDivElement,
  MoreOptionsButtonProps
>(
  (
    props: MoreOptionsButtonProps,
    ref
  ): React.ReactElement<MoreOptionsButtonProps> => {
    const { isPhone } = useContext(MediaContext);
    const [menuAnchorElement, setMenuAnchorElement] = React.useState<
      HTMLDivElement | undefined
    >(undefined);

    const onMenuOpen = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      setMenuAnchorElement(e.currentTarget.parentElement as HTMLDivElement);
    };

    const onMenuClose = () => setMenuAnchorElement(undefined);

    const onClick = (value: string) => {
      onMenuClose();
      props.onClick(value);
    };

    return (
      <Fragment>
        <div ref={ref}>
          <SFIconButton
            rotate="left"
            sfIcon="Other"
            sfSize="small"
            onClick={onMenuOpen}
            aria-label="More Options"
          />
        </div>

        <SFMenu
          autoFocus={false} // eslint-disable-line jsx-a11y/no-autofocus
          anchorEl={menuAnchorElement}
          open={Boolean(menuAnchorElement)}
          onClose={onMenuClose}
          variant="menu"
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            className: styles.menuPaper
          }}
        >
          {isPhone && props.isAdvancedFiltersActive && (
            <SFMenuItem onClick={() => onClick('filter')}>Filter by</SFMenuItem>
          )}
          {isPhone && (
            <SFMenuItem onClick={() => onClick('sortAndGroup')}>
              {props.sortLabel}
            </SFMenuItem>
          )}

          {isPhone && <SFDivider />}

          <SFMenuItem
            disabled={props.isDownloadDisabled}
            onClick={() => onClick('download')}
          >
            Download Reports
          </SFMenuItem>
        </SFMenu>
      </Fragment>
    );
  }
);
